module.exports = __webpack_public_path__ + "static/media/informed_logo.0b06ebf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/informed_logo.png
// module id = 1105
// module chunks = 1